var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 2",
    clipPath: "url(#clip0_823_1427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.33366 9.28667V11.9533L8.00033 14.5L12.667 11.9533V9.28667L8.00033 11.8333L3.33366 9.28667ZM8.00033 2.5L0.666992 6.5L8.00033 10.5L14.0003 7.22667V11.8333H15.3337V6.5L8.00033 2.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_823_1427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentCount);
export default __webpack_public_path__ + "static/media/student-count.a25d1be60fd5b2d2a4ab22e4c68fb1db.svg";
export { ForwardRef as ReactComponent };